import values from 'lodash/values';
import { InvalidRestaurantsOrderStatus, InvalidRestaurantsStatus } from '../../errors';
import { OperationalOrderStatus, RestaurantsOrderStatus } from '@wix/restaurants-types';

/** @deprecated */
export function getRestaurantsOrderStatus(orderId, fulfillmentStatusesAggregate) {
  var _fulfillmentStatusesA;
  const restaurantsOrderStatus = fulfillmentStatusesAggregate == null || (_fulfillmentStatusesA = fulfillmentStatusesAggregate.statuses) == null ? void 0 : _fulfillmentStatusesA[0];
  if (!restaurantsOrderStatus) {
    throw new InvalidRestaurantsStatus(orderId, restaurantsOrderStatus);
  }
  const isValid = values(RestaurantsOrderStatus).includes(restaurantsOrderStatus);
  if (!isValid) {
    throw new InvalidRestaurantsStatus(orderId, restaurantsOrderStatus);
  }
  return restaurantsOrderStatus;
}
export function getRestaurantsOrderStatusFromRestaurantsFulfillment(fulfillmentId, fulfillmentStatus) {
  if (!fulfillmentStatus) {
    throw new InvalidRestaurantsOrderStatus(fulfillmentId, fulfillmentStatus);
  }
  const isValid = values(RestaurantsOrderStatus).includes(fulfillmentStatus);
  if (!isValid) {
    throw new InvalidRestaurantsOrderStatus(fulfillmentId, fulfillmentStatus);
  }
  return fulfillmentStatus;
}
export function getOperationalOrderStatus(restaurantsOrderStatus) {
  const isOperationalOrderStatus = values(OperationalOrderStatus).includes(restaurantsOrderStatus);
  return isOperationalOrderStatus ? restaurantsOrderStatus : null;
}
//# sourceMappingURL=index.js.map